import { atomWithStorage } from 'jotai/utils';

export const OVERDUE_PAYMENT_STATE_STORAGE_KEY = 'overdue-payment-state';

export const defaultOverduePaymentState = {
  showBanner: false,
  showPopup: false,
  showPopover: false,
  overduePaymentId: undefined,
  sessions: [],
};

export const overduePaymentAtom = atomWithStorage<{
  showBanner: boolean;
  showPopup: boolean;
  showPopover: boolean;
  overduePaymentId?: string;
  sessions?: { id: string }[];
}>(OVERDUE_PAYMENT_STATE_STORAGE_KEY, defaultOverduePaymentState);

overduePaymentAtom.debugLabel = 'overduePaymentAtom';
